import React from 'react';

const withMemo = (WrappedComponent) => {
  return React.memo(WrappedComponent);
};

export default withMemo;